import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { getSavedLocation } from 'components/QueryRoute';

export const useProfileClose = (): (() => Promise<void>) => {
  const history = useHistory();

  const executor = useCallback(() => {
    history.replace(getSavedLocation());

    return Promise.resolve();
  }, []);

  return executor;
};
